// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"7f8b298a","243":"ff429cee","423":"5f358691","692":"23588ca6","708":"bcae552f","822":"b98cdbce"}[chunkId] + ".chunk.js";
};